import { getRequiredFields } from 'utils/form'
import constants from 'constants'

const fields = [
  {
    label: 'Partner name',
    name: 'partnerName',
    layout: 'fullWidth',
    maxLength: 50,
    disabled: true,
  },
  {
    label: 'Financial year',
    name: 'financialYear',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please select financial year',
  },
  {
    label: 'Status',
    name: 'planStatus',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please select plan status',
  },
  {
    label: constants.PARTNERPLAN.PROGRESS_LABEL.AGREED_WITH_COUNSELLEE,
    name: 'planAgreedWithCounsellee',
    validators: [
      {
        check: 'requiredCheckedIf',
        fields: 'planAgreedWithCounsellee|planStatus',
        error: constants.PARTNERPLAN.ERROR_MESSAGE.AGREED_WITH_COUNSELLEE,
        conditions: constants.PARTNERPLAN.STATUS.AGREED,
      },
      {
        check: 'requiredCheckedIf',
        fields: 'planAgreedWithCounsellee|planStatus',
        error: constants.PARTNERPLAN.ERROR_MESSAGE.AGREED_WITH_COUNSELLEE,
        conditions: constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED,
      },
      {
        check: 'requiredCheckedIf',
        fields: 'planAgreedWithCounsellee|planStatus',
        error: constants.PARTNERPLAN.ERROR_MESSAGE.AGREED_WITH_COUNSELLEE,
        conditions: constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED,
      },
    ],
  },  
  {
    label: 'Partner assessment',
    name: 'planRating',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'planRating|planStatus',
        error: 'Please enter an assessment rating',
        conditions: constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED,
      },
      {
        check: 'requiredIf',
        fields: 'planRating|planStatus',
        error: 'Please enter an assessment rating',
        conditions: constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED,
      },
      {
        check: 'requiredIf',
        fields: 'planRating|planStatus',
        error: 'Please enter an assessment rating',
        conditions: constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED,
      },
      {
        check: 'requiredIf',
        fields: 'planRating|planStatus',
        error: 'Please enter an assessment rating',
        conditions: constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED,
      },
    ],
  },
  {
    label: 'Add a note',
    name: 'note',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'note|planRating',
        error: 'If you have selected "Not eligible" you must provide reasons in the note section.',
        conditions: constants.PARTNERPLAN.RATINGS.NOT_ELIGABLE,
      },
    ],
  },   
  {
    label: 'Partner exemption',
    name: 'planExemption',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'planExemption|planStatus',
        error: 'Please select exemption reason',
        conditions: constants.PARTNERPLAN.STATUS.EXEMPT,
      },
    ],
  },
  {
    label: 'Add a note',
    name: 'planExemptionOther',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'requiredIf',
        fields: 'planExemptionOther|planExemption',
        error: 'If you have selected "Other" you must provide reasons in the note section.',
        conditions: 'Other',
      },
    ],
  },  
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/PartnerPlanStatusForm.js